import React from 'react';
import { makeStyles } from '@mui/styles';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import businessObjectService from '../../../../../../services/business-object.service';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import { Grid, LinearProgress } from '@mui/material';
import logger from '../../../../../../commons/logger';

const useStyles = makeStyles({
  paper: {
    marginBottom: '20px',
    padding: '20px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  toolbar: {
    width: '100%',
    padding: 0,
  },
  title: {
    flexGrow: 1,
  },
});

interface BusinessObjectBookingSettingsComponentProps {
  ownerId?: number;
  ownerEmail?: string;
  businessObject?: BusinessObject;
  onBoChange: Function;
}

export default function BusinessObjectBookingSettingsComponent(props: BusinessObjectBookingSettingsComponentProps) {
  const [rwgActive, setRwgActive] = React.useState<boolean>(false);
  const [isTestingBo, setIsTestingBo] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setRwgActive(props.businessObject?.rwgActive);
    setIsTestingBo(props.businessObject?.testing);
  }, [props]);

  const saveRwgActiveFlag = async () => {
    try {
      setIsLoading(true);

      const boToSubmit = { ...(props.businessObject || {}) };
      boToSubmit.rwgActive = !rwgActive;

      const response = await businessObjectService.updateBusinessObject(boToSubmit);

      if (response?.id) {
        props.onBoChange();
      }
    } catch (e) {
      logger.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const saveOnlineSearchActiveFlag = async () => {
    try {
      setIsLoading(true);

      const boToSubmit = { ...(props.businessObject || {}) };
      boToSubmit.testing = !isTestingBo;

      const response = await businessObjectService.updateBusinessObject(boToSubmit);

      if (response?.id) {
        props.onBoChange();
      }
    } catch (e) {
      logger.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h6" className={classes.title}>
          Booking settings
        </Typography>
      </Toolbar>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormControlLabel
            control={<Switch checked={rwgActive} disabled={isLoading} onChange={saveRwgActiveFlag} />}
            label="Reserve with Google"
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={!isTestingBo}
                disabled={isLoading || !props?.businessObject?.urlName}
                onChange={saveOnlineSearchActiveFlag}
              />
            }
            label="Online searching"
          />
          {!props?.businessObject?.urlName ? <div>URL name is required</div> : <></>}
        </Grid>
      </Grid>

      {isLoading ? <LinearProgress /> : <></>}
    </Paper>
  );
}
